<template>
  <a-card :bordered="false">
    <a-row>
      <a-col :span="9">
        <div class="title-name">{{ ticketName }}( 商品ID:{{ erpTicketId }}) 匹配信息</div>
        <ul class="ul-content" v-if="erpTicketInfo">
          <li><span class="left-labei">所在城市：</span><span class="right-content">{{ erpTicketInfo.cityName }}</span>
          </li>
          <li><span class="left-labei">名称：</span><span class="right-content">{{ erpTicketInfo.ticketName }}</span>
          </li>
          <li><span class="left-labei">电话：</span><span class="right-content">{{ erpTicketInfo.hotelPhone }}</span>
          </li>
          <li><span class="left-labei">地址：</span><span class="right-content">{{ erpTicketInfo.ticketAddress }}</span>
          </li>
          <li v-if="erpTicketInfo.longitude&&erpTicketInfo.latitude"><span class="left-labei">经纬度：</span><span
            class="right-content">{{ erpTicketInfo.longitude }}/{{ erpTicketInfo.latitude }}</span></li>
        </ul>
      </a-col>
      <a-col :span="15" class="relative-class">
        <detail-list title="推荐的可匹配景点">
          <div>
            <a-input v-model="queryParams.ticketId" placeholder="请输入商品ID" style="width: 200px;"></a-input>
            <a-input v-model="queryParams.ticketName" placeholder="请输入商品名称/关键词"
                     style="width: 300px;margin: 0 40px 0 20px"></a-input>
            <a-button type="primary" @click="searchBtn">搜索</a-button>
          </div>
          <div class="search-list">
            <div style="margin-top: 20px" class="recommend-name">已匹配景点</div>
            <a-table
              :columns="proColumns"
              rowKey="ticketId"
              :dataSource="searchDataList" :pagination="false"
              :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}">
              <template slot="latSlots" slot-scope="text, record">
                <div>经:{{ record.longitude }}</div>
                <div>纬:{{ record.latitude }}</div>
              </template>
            </a-table>
            <div class="recommend-name" style="margin-top: 20px;">建议匹配景点</div>
            <custom-page-table
              ref="table"
              rowKey="ticketId"
              :columns="proColumns"
              :enableSearch="false"
              :queryParams="queryParams"
              :requestPromise="loadPromise"
              :rowSelection="{ selectedRowKeys: searchRowKeys, onChange: onSearchChange,getCheckboxProps:onCheckboxProps }"
            >
              <template slot="latSlots" slot-scope="data">
                <div>经:{{ data.record.longitude }}</div>
                <div>纬:{{ data.record.latitude }}</div>
              </template>
            </custom-page-table>
          </div>
          <div class="btns">
            <a-button type="primary" :loading="loading" @click="onSubmitData">提交</a-button>
            <a-button style="margin-left: 20px;" @click="goBack">返回</a-button>
          </div>
        </detail-list>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
export default {
  name: 'ManualMatch',
  data() {
    return {
      loadPromise: params => this.getListPromise(params),
      ticketName: this.$route.query.ticketName,
      erpTicketId: this.$route.query.erpTicketId,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      proColumns: [
        {
          title: '商品ID ',
          dataIndex: 'ticketId'
        },
        {
          title: '商品名称',
          dataIndex: 'ticketName'
        },
        {
          title: '联系电话',
          dataIndex: 'ticketPhone'
        },
        {
          title: '地址',
          dataIndex: 'ticketAddress'
        },
        {
          title: '经纬度',
          dataIndex: 'Latitude',
          scopedSlots: { customRender: 'latSlots' }
        }
      ],
      erpTicketInfo: {},
      searchDataList: [],
      selectedRowKeys: [],
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      searchRowKeys: [],
      loading: false
    }
  },
  mounted() {
    this.getDetailList()
  },
  methods: {
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    getListPromise(params) {
      if (params.ticketId || params.ticketName) {
        return this.getHttpServices().getCloudProService().post('erp/queryPlatformTicketList', params)
      } else {
        return new Promise((resolve, reject) => {
          const result = {
            pageSize: 10,
            pageNo: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
    },
    onSearchChange(selectedRowKeys, selectedRows) {
      this.searchRowKeys = selectedRowKeys
    },
    onSubmitData() {
      this.loading = true
      let list = [...this.selectedRowKeys, ...this.searchRowKeys]
      if (list && list.length > 5) {
        this.$message.error('最多可匹配5个门票')
        return
      }
      let params = {
        erpTicketId: this.erpTicketId,
        matchProIdList: this.selectedRowKeys,
        merchantId: this.merchantId,
        platformId: this.platformId,
        outerProIdList: this.searchRowKeys
      }
      this.getHttpServices().getCloudProService().post('erp/matchPlatformTicket', params).then(res => {
        this.$message.success('保存成功')
        this.loading = false
        setTimeout(() => {
          this.goBack()
        }, 500)
      }).catch(reason => {
        this.loading = false
        this.showNetWorkErrorMessage(reason)
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    onCheckboxProps: record => ({
      props: {
        disabled: record.add === false // Column configuration not to be checked
      }
    }),
    getDetailList() {
      let params = {
        erpTicketId: this.erpTicketId,
        merchantId: this.merchantId,
        platformId: this.platformId,
        searchOption: false
      }
      this.getHttpServices().getCloudProService().post('erp/queryErpTicketMatchDetails', params).then(res => {
        if (res.erpTicketInfo) {
          this.erpTicketInfo = res.erpTicketInfo
        }
        if (res.matchTicketInfo && res.matchTicketInfo.length > 0) {
          this.searchDataList = res.matchTicketInfo
          this.selectedRowKeys = res.matchTicketInfo.map(item => {
            return item.ticketId
          })
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style lang="less">
.relative-class {
  position: relative;
}

.check {
  position: absolute;
  top: 0;
  left: 0;
}

.bottom {
  position: absolute;
  bottom: -50px;
  left: 0;
}

.ant-card-head {
  margin: 0 24px -1px 0;
  padding: 0;
}

.title-name {
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 10px;
}

.ul-content {
  li {
    display: flex;
    line-height: 30px;
    align-items: center;

    .left-labei {
      width: 70px;
      text-align: right;
    }
  }
}

.search-list {
  cursor: pointer;

  .ul-box {
    margin-bottom: 15px;
    display: inline-block;

    li {
      line-height: 25px;
      padding-left: 25px;
    }
  }
}

.btns {
  padding: 28px;
}
</style>